import { render } from "./ComponentPresentationDynamic.vue?vue&type=template&id=6aa16310&scoped=true"
import script from "./ComponentPresentationDynamic.vue?vue&type=script&lang=js"
export * from "./ComponentPresentationDynamic.vue?vue&type=script&lang=js"

import "./ComponentPresentationDynamic.vue?vue&type=style&index=0&id=6aa16310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa16310"]])

export default __exports__